module.exports = __webpack_public_path__ + "assets/img/00190.53bb9955.png";